module.exports = __webpack_public_path__ + "static/media/combo_ride_4.71007907.png";